import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RelatedDocuments = ({ documents, onDocumentClick }) => {
  const getDocumentIcon = (type) => {
    switch (type) {
      case 'imaging':
        return 'Image';
      case 'pathology':
        return 'Microscope';
      case 'clinical-note':
        return 'FileText';
      case 'report':
        return 'FileBarChart';
      default:
        return 'File';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground">Related Documents</h3>
        <Icon name="FolderOpen" size={24} color="var(--color-primary)" />
      </div>
      <div className="space-y-3">
        {documents?.map((doc) => (
          <button
            key={doc?.id}
            onClick={() => onDocumentClick(doc)}
            className="flex items-start gap-3 md:gap-4 w-full p-3 md:p-4 rounded-lg border border-border hover:bg-muted transition-smooth text-left"
          >
            <div className="flex-shrink-0">
              <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg">
                <Icon name={getDocumentIcon(doc?.type)} size={20} color="var(--color-primary)" />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm md:text-base font-medium text-foreground mb-1">{doc?.title}</p>
              <p className="text-xs md:text-sm text-muted-foreground mb-2">{doc?.description}</p>
              <div className="flex items-center gap-4 text-xs text-muted-foreground">
                <span>{doc?.date}</span>
                <span>•</span>
                <span>{doc?.provider}</span>
              </div>
            </div>
            <Icon name="ChevronRight" size={18} className="flex-shrink-0 text-muted-foreground" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default RelatedDocuments;